import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { AuthService } from '../../services/auth.service';
import { jwtDecode } from 'jwt-decode';
import { CartService } from '../../services/cart.service';
import { ToastService } from '../../toast.service';
import { ToastModalComponent } from '../../toast-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({ selector: 'app-vendor-register', templateUrl: './vendor-register.component.html' })
export class VendorRegisterComponent {
  model: any = {};
  loading = false;
  message = '';
  error = '';
  private loggedIn = new BehaviorSubject<boolean>(false);
  private userRole = new BehaviorSubject<string | null>(null);

  loggedIn$ = this.loggedIn.asObservable();
  userRole$ = this.userRole.asObservable();

  constructor(private auth: AuthService,
    private vendorService: VendorService,
    private router: Router,
    private cartService: CartService,
    private toast: ToastService,
    private dialog: MatDialog) {
  }


  submit() {
    this.loading = true;
    this.message = '';
    this.error = '';
    this.vendorService.register(this.model).subscribe({
      next: (res) => {
        localStorage.setItem('token', res.token);
        const decodedToken: any = jwtDecode(res.token);
        localStorage.setItem('userId', decodedToken?.userId); // or whatever field carries the userId
        localStorage.setItem('role', this.auth.getUserRole() ?? '');

        const currentTime = Math.floor(Date.now() / 1000);
        //If token expired
        if (decodedToken.exp < currentTime) {
          // Redirect to login if unauthorized
          this.auth.logout();
          /*          this.router.navigate(['/login']);*/
        }
        else {
          this.cartService.refreshCartCount();
        }

        this.loggedIn.next(true);
        this.userRole.next(localStorage.getItem('role'));

        this.router.navigate(['/']); // go to home

        //this.toast.show('Registration submitted. Please await for the admin approval.');

          this.dialog.open(ToastModalComponent, {
            data: {
              title: 'Success!',
              message: 'Vendor registration submitted successfully! Please wait for admin approval. In the meantime, you can continue shopping as a valued customer.'
            },
            width: '400px',
            disableClose: true,
          });


        this.loading = false;
        //this.router.navigate(['/vendor/pending']);
      },
      error: (err) => {
        this.error = err?.error || 'Registration failed';
        this.loading = false;
      }

    });
  }
}
